import { Ban, Check } from 'lucide-react'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <Check className="text-success size-5" />,
        error: <Ban className="text-error size-5" />,
      }}
      toastOptions={{
        classNames: {
          success:
            'h-[57px] text-primary text-lg font-semibold w-full rounded-r-[10px] rounded-l-[4px] flex items-center gap-2 px-4 border-l-[4px] border-success shadow-[0px_1px_4px] shadow-[#000]/15 bg-white',
          error:
            'h-[57px] text-primary text-lg font-semibold w-full rounded-r-[10px] rounded-l-[4px] flex items-center gap-2 px-4 border-l-[4px] border-error shadow-[0px_1px_4px] shadow-[#000]/15 bg-white',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
